import React from "react";
import { FaGithub, FaEnvelope, FaLinkedin } from 'react-icons/fa';
import { sendEvent } from "../utils/gtag";

const allMembers = [
    
    {
      id: 1,
      name: "Md Atikqur Rahaman",
      role: "Lead Advisor",
      img: "/team_image/Atik Sir.jpg",
      description: "Offering strategic business insights.",
      github: "mailto:atik@techvelly.com",
      linkedin: "#",
      icon: <FaEnvelope />
    },
    {
      id: 2,
      name: "Chinmay Bepery",
      role: "Consultant (IT)",
      img: "/team_image/Chinmay Sir.jpg",
      description: "Providing expert IT consultancy services.",
      github: "mailto:chinmay@techvelly.com",
      linkedin: "#",
      icon: <FaEnvelope />
    },
    {
      id: 3,
      name: "Moinul Islam Sayed",
      role: "Consultant (IT and Business Development)",
      img: "/team_image/Sayed.jpg",
      description: "Providing expert Business Development consultancy services.",
      github: "mailto:sayed@techvelly.com",
      linkedin: "#",
      icon: <FaEnvelope />
    },
    {
      id: 4,
      name: "Md.Atiqur Rahman",
      role: "Consultant (Finance)",
      img: "/team_image/Atik_02.jpg",
      description: "Providing expert Financial consultancy services.",
      github: "mailto:atiq.fin@techvelly.com",
      linkedin: "#",
      icon: <FaEnvelope />
    },
    {
      id: 5,
      name: "Md. Mahmudul Hasan Faisal",
      role: "Chief Executive Officer",
      img: "/team_image/Md. Mahmudul Hasan Faisal.png",
      description: "",
      github: "https://github.com/mhfaisalbd",
      icon: <FaGithub />,
      linkedin: "https://www.linkedin.com/in/bdmhfaisal",
    }
    ,
     {
      id: 6,
      name: "Tamjidul Alam",
      role: "Head of Marketing & Business Development",
      img: "/team_image/Tamjidul Alam.png",
      description: "",
      github: "https://github.com/Tamjidulalam",
      linkedin: "https://www.linkedin.com/in/tamjidulalam/",
    },
    {
      id: 7,
      name: "Surajit Biswas",
      role: "Business Development Manager",
      img: "/team_image/Surajit Biswas.png",
      description: "",
      github: "https://github.com/surajit14cse",
      linkedin: "https://www.linkedin.com/in/surajit-biswas-5a6665199/",
    },
    {
      id: 8,
      name: "Moin Uddin",
      role: "Developer",
      img: "/team_image/Moin Uddin.png",
      description: "",
      github: "https://github.com/MoinBinNizam",
      linkedin: "https://www.linkedin.com/in/m-moinuddin/",
    },
     
    {
      id: 9,
      name: "Hasibur Rahman Hasib",
      role: "Developer",
      img: "/team_image/Hasibur Rahman Hasib.png",
      description: "",
      github: "https://github.com/hasib-codebreaker",
      linkedin: "#",
    },
    {
      id: 10,
      name: "Rafid Al Nahiyan",
      role: "Developer",
      img: "/team_image/Rafid Al Nahiyan.png",
      description: "",
      github: "https://github.com/Rafid41",
      linkedin: "https://www.linkedin.com/in/rafid-al-nahiyan-8b63b7217/",
    },
    {
      id: 11,
      name: "Dinesh Sarkar",
      role: "Marketing Officer",
      img: "/team_image/Dinesh Sarkar.png",
      description: "",
      github: "https://github.com/sarkardinesh",
      linkedin: "https://www.linkedin.com/in/dinesh-sarkar/",
    },
   
    // Add more members as needed
  ];

const row1 = allMembers.filter(m => m.name === "Chinmay Bepery" || m.name === "Md Atikqur Rahaman"  || m.name === "Moinul Islam Sayed");
const row2 = allMembers.filter(m => m.name === "Md.Atiqur Rahman" || m.name === "Md. Mahmudul Hasan Faisal" || m.name === "Tamjidul Alam");
const restOfTheTeam = allMembers.filter(m => !row1.includes(m) && !row2.includes(m));


const TeamMemberCard = ({ member, icon }) => (
    <div className="group relative bg-gray-800 text-white p-6 rounded-lg shadow-lg transform hover:-translate-y-2 transition-transform duration-300 overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-purple-500 to-pink-500 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"></div>
        <div className="relative z-10 flex flex-col items-center text-center">
            <div className="w-32 h-32 rounded-full overflow-hidden mb-4 border-4 border-gray-700 group-hover:border-purple-500 transition-colors duration-300">
                <img
                    src={member.img}
                    alt={member.name}
                    className="w-full h-full object-cover"
                />
            </div>
            <h3 className="text-xl font-bold">{member.name}</h3>
            <p className="text-purple-400">{member.role}</p>
            <p className="text-sm text-gray-400 mt-2">{member.description}</p>
            <div className="flex space-x-4 mt-4">
                <a 
                    href={member.github} 
                    onClick={() => sendEvent('team_member_contact_click', { member_name: member.name, type: member.github.startsWith('mailto:') ? 'email' : 'github' })}
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="text-gray-400 hover:text-white transition-colors duration-300">
                    {member.icon || <FaGithub/>}
                </a>
                {member.linkedin && member.linkedin !== '#' && (
                    <a 
                        href={member.linkedin} 
                        onClick={() => sendEvent('team_member_contact_click', { member_name: member.name, type: 'linkedin' })}
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className="text-gray-400 hover:text-white transition-colors duration-300">
                        <FaLinkedin/>
                    </a>
                )}
            </div>
        </div>
    </div>
);

const TeamPage = () => {
  return (
    <div className="min-h-screen w-full bg-gray-900 text-white p-8">
        <div className="container mx-auto">
            <header className="text-center mb-16">
                <h1 className="text-5xl font-bold mb-2">Meet Our Team</h1>
                <p className="text-lg text-gray-400">The minds behind our success</p>
            </header>

            <main className="flex flex-col items-center space-y-12">
                {/* Row 1 */}
                {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-8 w-full max-w-4xl"> */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8 w-full max-w-6xl">
                {row1.map((member, index) => (
                    <TeamMemberCard key={index} member={member} icon={<FaEnvelope/>} />
                ))}
                </div>

                {/* Row 2 */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8 w-full max-w-6xl">
                {row2.map((member, index) => (
                    <TeamMemberCard key={index} member={member} icon={<FaGithub/>} />
                ))}
                </div>

                {/* Rest of the team */}
                <div className="w-full">
                    <h2 className="text-3xl font-bold text-center mb-8">Our Experts</h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
                        {restOfTheTeam.map((member, index) => (
                            <TeamMemberCard key={index} member={member} />
                        ))}
                    </div>
                </div>
            </main>
        </div>
    </div>
  );
};

export default TeamPage;
